<template>

    <div class="pimBrands">

        <!-- page-heading -->
        <page-heading :pageTitle="pageTitle" backRoute="pimProducts"></page-heading>


        <div class="columns">

            <div class="col-main">
                <v-server-table ref="pimBrandsTable" name="pimBrandsTable" class="pimBrandsTable" :columns="table.tblColumns" :options="table.tblOptions">
                    

                    <!-- before table: FILTER OPTIONS -->
                    <template slot="beforeTable">

                        <div class="columns is-marginless filters">

                            <!-- SUCHE -->
                            <div class="column">
                                <div class="control has-icon search" style="min-width:150px;">
                                <input class="input" type="text" v-model.trim="searchTerm" placeholder="Suchbegriff">
                                <i class="fa fa-search" aria-hidden="true"></i>
                                </div>
                            </div>

                        </div>  

                    </template>

                    <!-- loading indicator -->
                    <template v-if="isLoadingTableData" slot="afterBody">

                        <div class="overlay-loader"></div>
                        <loading-indicator size="36px"></loading-indicator>
                        
                    </template>

                    <!-- logoAsset -->
                    <template slot="logoAsset" slot-scope="props">
                        <div v-if="props.row.logoAsset">
                            <div class="imgWrapper lazy-img-fadein" v-lazy:background-image="getImagePath(props.row.logoAsset, false)"></div>
                        </div>
                        <div v-else class="imgWrapper placeholder-asset" style="display: flex; align-items: center; justify-content: center; background: #fafafa; border: 1px solid #efefef; border-radius: 2px;">
                            <i class="fa fa-picture-o" style="color: #ccc; font-size: 18px;"></i>
                        </div>
                    </template>

                    <!-- name -->
                    <template slot="name" slot-scope="props">

                        {{ props.row.name }}
              
                    </template>

                    <!-- productCount -->
                    <template slot="productCount" slot-scope="props">

                        {{ props.row.productCount }}
              
                    </template>



                    <!-- groups -->
                    <template slot="groups" slot-scope="props">
                        <span
                            v-if="props.row.groups && props.row.groups.length > 0"
                            class="groups-tags">
                            <span
                                v-for="g in props.row.groups"
                                :key="g.id"
                                class="tag is-light is-small group-tag">
                                {{ g.name }}
                            </span>
                        </span>
                        <span v-else class="no-groups">—</span>
                    </template>

                    <!-- sanova -->
                    <template slot="sanova" slot-scope="props">
                        <span v-if="props.row.sanova === true || props.row.sanova === 1" class="tag is-success is-small">Ja</span>
                        <span v-else class="tag is-light is-small">—</span>
                    </template>

                    <!-- actions -->
                    <template slot="actions" slot-scope="props">
                        <span class="icon is-small" @click.stop="brandEdit(props.row)" title="Bearbeiten" style="cursor: pointer;">
                            <i class="icon-ak-bearbeiten"></i>
                        </span>
                    </template>

                </v-server-table>

            </div>

        </div>  



    </div>        
</template>

<script>
import Vue from 'vue';
import { ServerTable, Event } from 'vue-tables-2';
Vue.use(ServerTable, {}, false, 'bulma');
import { debounce } from "debounce";


export default {
    name: 'pimBrands',

    components: {
    },
    data() {
        var self = this;
        return {
            
            searchTerm: sessionStorage.getItem('pimBrandsSearchTerm') || '',
            isLoadingTableData: false,



            pageTitle: 'PIM-BRANDS-HEADER',

                table: {

                    tblColumns: ['logoAsset', 'name', 'productCount', 'groups', 'sanova', 'actions'],

                    tblOptions: {

                        requestFunction(data) {

                            self.isLoadingTableData = true;                      

                            data['limit'] = data.limit || 15;
                            data['page'] = data.page || 1;

                            let url = this.$config.api + 'pimBrand?filters[name]=!EMPTY&orderBy=name&order=asc&include=pimBrand.pimBrandGroups,pimBrand.logoAsset&limit=' + data.limit + '&page=' + data.page;
                            if (self.searchTerm) {
                                url += '&search=' + encodeURIComponent(self.searchTerm) + '&searchFields=name';
                            }

                            return this.axios.get(url)
                                .then(response => {
                                    const items = response.data.pimBrand.items.map(brand => ({
                                        ...brand,
                                        groups: brand.pimBrandGroups || []
                                    }));
                                    return {
                                        data: items,
                                        count: response.data.pimBrand.total
                                    }
                                }).catch(function (e) {
                                    console.log("error ... :", e.message);
                                }.bind(this))
                                .finally(() => {
                                    self.isLoadingTableData = false;
                                })

                        },

                        uniqueKey: 'id',
                        perPage: 15,

                        sortIcon: {
                            base:'fa',
                            up:'fa-sort-up',
                            down:'fa-sort-down',
                            is:'fa-sort'
                        },
                        saveState: true,
                        preserveState: true,
                        filterable: true,
                        headings: {

                            logoAsset() {
                                return "Bild";
                            },
                            name(h) { // eslint-disable-line no-unused-vars
                                return <lang labelKey="PIM-BRANDS-TABLE_HEADING-NAME"></lang>
                            },
                            productCount(h) { // eslint-disable-line no-unused-vars
                                return <lang labelKey="PIM-BRANDS-TABLE_HEADING-PRODUCT-COUNT"></lang>
                            },
                            groups() {
                                return 'Gruppen';
                            },
                            actions() {
                                return "";
                            },
                            sanova(h) { // eslint-disable-line no-unused-vars
                                return <lang labelKey="PIM-BRANDS-TABLE_HEADING-SANOVA"></lang>
                            },
                        },
                        // sortable: ['name', 'productCount', 'sanova'],
                        sortable: [],
                        texts: {
                            first:'Anfang',
                            last:'Ende',
                            filter: 'Filter Ergebnisse:',
                            filterPlaceholder: 'Suche',
                            limit: 'Einträge pro Seite',
                            noResults: 'keine passenden Einträge gefunden',
                            count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag',
                            loading: 'Lade Daten ...'
                        },
                        pagination: {
                            dropdown: false,
                            chunk: 5,
                            edge: false
                        },

                        initialPage: parseInt(sessionStorage.getItem('pimBrandsTablePage')) || 1,
                        skin: 'table is-striped is-hoverable is-fullwidth',

                        columnsClasses: {
                            'logoAsset': 'asset',
                            'name': 'name',
                            'productCount': 'productCount',
                            'groups': 'groups',
                            'sanova': 'sanova',
                            'actions': 'actions'
                        },

                    }
                },


        }
    },


    methods: {
        
        filter() {
            this.$refs.pimBrandsTable.setFilter(this.searchTerm || '');
        },
        
        performSearch: debounce(function () {
            this.filter();
        }, 500),



        brandEdit(row) {
            this.$router.push({ name: 'pimBrandDetail', params: { id: row.id }});
        },

        getImagePath(asset, thumb=false) {
            if(!asset) {
                return "";
            }

            let path = asset.path ? asset.path : 'dam/pimBrand';
            return this.$config.cdnHost + "apokat-backend/assets/" + path + "/" + (thumb != false ? '' : '') + asset.filename;
        }

    },


    mounted() {
        Event.$on('vue-tables.pimBrandsTable.pagination', (page) => {
            sessionStorage.setItem('pimBrandsTablePage', page);
        });
    },

    beforeDestroy() {
        Event.$off('vue-tables.pimBrandsTable.pagination');
    },

    watch: {

        searchTerm(val) {
            sessionStorage.setItem('pimBrandsSearchTerm', val || '');
            sessionStorage.setItem('pimBrandsTablePage', 1);
            this.performSearch();
        },

    },

}
</script>

<style lang="scss" scoped>


.pimBrandsTable {
  ::v-deep > .columns:first-child {
    display: none !important;
  }

  ::v-deep .VueTables__table {
    position: relative !important;
  }

  .overlay-loader {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: white;
    opacity: 0.65;
  }

  ::v-deep .v-spinner {
    position: absolute !important;
    z-index: 999;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%);
  }

  ::v-deep .table {

    #VueTables_th--logoAsset {
      width: 100px;
    }
    #VueTables_th--actions {
      max-width: 50px;
      width: 50px;
    }
    #VueTables_th--groups {

    }
    #VueTables_th--sanova {
        max-width: 80px;
        width: 80px;
        text-align: center;
    }
    #VueTables_th--productCount {
      max-width: 150px;
      width: 150px;
    }
    td {
        vertical-align: middle;
        cursor: default !important;
        padding-top: 8px;
        padding-bottom: 8px;

        &.asset {
            width: 100px;
            .imgWrapper {
                background-repeat: no-repeat;
                background-position: 50% 50% !important;
                background-size: contain;
                width: 65px;
                height: 45px;
                margin: 0;
                background-color: #FFF;
                border: 1px solid #efefef;
                border-radius: 2px;
            }

            .imgWrapper[lazy=loading] {
                background-size: 30% !important;
            }
        }



        &.sanova {
            width: 80px;
            max-width: 80px;
            text-align: center;
        }

        &.actions {
            width: 80px;
            max-width: 80px;
        }

        &.groups {
            width: 200px;
            max-width: 200px;
            .groups-tags {
                display: flex;
                flex-wrap: wrap;
                gap: 3px;
            }
            .group-tag {
                background: #eaf0fb;
                color: #3273dc;
                border: 1px solid #c5d9f7;
            }
            .no-groups {
                color: #ccc;
            }
        }
    }
  }

  ::v-deep .edit-groups-btn {
    color: #999;
    transition: color .2s;

    &:hover {
      color: #3273dc;
    }
  }


}
</style>
